<t-llevo-dialog-header
  dialogTitle="Cambiar Contraseña"
  mat-dialog-title
></t-llevo-dialog-header>

<mat-dialog-content commonui-loader [appLoader]="loading() ?? false">
  <form [formGroup]="frm" class="formGroup">
    <mat-form-field>
      <mat-label>Nueva contraseña</mat-label>
      <input
        matInput
        [type]="hidePassword ? 'password' : 'text'"
        formControlName="newPassword"
        (input)="matchPasswords()"
      />
      <button
        type="button"
        mat-icon-button
        matSuffix
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hidePassword"
      >
        <mat-icon [svgIcon]="hidePassword ? 'eye-off' : 'eye'"></mat-icon>
      </button>
      @if(newPassword.hasError('required')){
        <mat-error>Campo requerido</mat-error>
      }
      @else if(newPassword.hasError('minlength')){
        <mat-error>La contraseña debe contener más de {{newPassword.errors!['minlength']['requiredLength']}} carácteres</mat-error>
      }
      @else if (newPassword.hasError('pattern')) {
        <mat-error>La contraseña debe contener una letra en mayúscula, una en minúscula, un número y un carácter especial</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Repetir contraseña</mat-label>
      <input
        matInput
        [type]="hidePassword ? 'password' : 'text'"
        formControlName="confirmPassword"
        (input)="matchPasswords()"
      />
      <button
        type="button"
        mat-icon-button
        matSuffix
        (click)="hidePassword = !hidePassword"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hidePassword"
      >
        <mat-icon [svgIcon]="hidePassword ? 'eye-off' : 'eye'"></mat-icon>
      </button>
      @if(confirmPassword.hasError('required')){
        <mat-error>Campo requerido</mat-error>
      }
      @else if(confirmPassword.hasError('minlength')){
        <mat-error>La contraseña debe contener más de {{confirmPassword.errors!['minlength']['requiredLength']}} carácteres</mat-error>
      }
      @else if (confirmPassword.hasError('pattern')) {
        <mat-error>La contraseña debe contener una letra en mayúscula, una en minúscula, un número y un carácter especial</mat-error>
      } 
      @else if(confirmPassword.hasError('PasswordNoMatch')){
        <mat-error> La contraseñas no coinciden </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="frm.invalid || frm.pristine || loading()" 
    color="accent"
  >
    Guardar cambios
  </button>
</mat-dialog-actions>
